import {useMutation, useQuery} from '@tanstack/react-query';
import {
  getIpRestrictionDetails,
  postIPRestrictions,
} from '../../api/endpoints/ipRestrictionApi';
import {IPConfig} from '../../api/types/ipRestrictionApi.type';

export const useGetIpRestriction = () => {
  return useQuery<IPConfig, Error>({
    queryKey: ['ipRestrictionList'],
    queryFn: async () => {
      return getIpRestrictionDetails();
    },
    retry: 2,
  });
};

export const usePostIpRestrictions = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: postIPRestrictions,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
